var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof Order !== "undefined") return resolve();
	__webpack_require__.l("https://d2qu3wufxz5mec.cloudfront.net/ptec-commons-frontend-order-mf/remoteEntry.js?1.0.7", function(event) {
		if(typeof Order !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "Order");
}).then(function() { return Order; });